var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAwaitingAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "url(#pattern0_14501_73600)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_14501_73600",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_14501_73600",
    transform: "scale(0.02)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_14501_73600",
    width: 50,
    height: 50,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAADZ0lEQVR4nO2ZXYhNURTHN/I5FB6IfDwo5CNK4UWDzMxZ64yP5CLPJKW8oBQOcdY6M5OvkGbuXfvOTBH3RXhQvh6UpIgIJeJB4UF48c1o32lm9r1mxr3m3rlHzq923Ye99t7/vddee61zlYqIiIiIKBDCeFYzXDatsdaZpP5VhOGdZmwxLbkfZ6t/FYmEhAyJhIQMiYT8BU1B9YQE4zZhvCIET4TwjRDeF8KTEuDqI0ecgSrMQprrKsqE8LAwfGmbrLMmhM/Fd1aFUkhD4IwThrvdCfitEdS2tKg+oRGSqFk2TDM8yNx1eKIJdgi7S4RwnvZxpTA2CMHHTDHohUaIZtSW2/wUhj319XP6d9p3X+V4Ibxp99e+u6DkQhqDqulC8N1ylx053SXLDY2wkgsRhrr2BTHc8Tyvby52jezOSZ9Gm63vTMvFLunDiiS7sXTzlg9XhUIzPuzweVifj60Q3LDuylZVSoTxU/tR+9VT87HVjDXWxT+hSkXqQGywHYGa6ypG5WMvPmzvcEs8nZMNwx5hCExL1Cwb+9eL7+7y6QBm5mOrCQ5abnmo1Jf9jrWYLfnYaoJ7VrTbXFIhmnGnFUafprzYgNwW5C6xNuCHeV9K6lqJfThRE361QvDxP9nE/aWjNcMLy+aiCgOaYG9GesLQHD9QObKzvsnAma8ZnlmpzMdETdUUFQZSXmyAMFzPEvNOCONJHzYkA3eteSda03rrETS/A9yowkRzXUWZZriWT/YrgbNJhYl6r3qIEOzShO/zEsJwN0noqDAg7M4ShsddLPabMLzUBI804dtuCq242YySiUiQU5ldX5iyVhOwqUGyE0hTt5hkTxOcSYfczCLr1kl2R/S+CB8XacLPVtL31cT4Y1750Nzs3RlCeDXL1W736snU768aIwSvLBFvNcPifMdJpWL9zMOW6WpwSvUWQnjefgfigTu3J+OZ2j3r3iwv3Gq7wOx8xqQBrFM9JH0yhJfser+rUrlgaMYLlk9fL9S4TQSTTZTrqG1ghSoW8XSOZE3G7sJCjq8Jm6y7cq6QY2egCdZYE73OtT7PlUSArlVofTAup4qBXQgJQ2Ohx0965YPsr5QmRKti0PqQte/Y7mLMYT6ndgQSt6pYQrjtj0jNztJizCGMR9vmMI+uioiIiPhv+AWe2YNrAVZzlQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwaitingAction);
export default __webpack_public_path__ + "static/media/AwaitingAction.00f8fd983ff92587f99f7c69f763da10.svg";
export { ForwardRef as ReactComponent };